import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NavigationStateService {
    private fromButtonClick = false;
    private readonly STORAGE_KEY = 'navigation_from_button';
    private readonly ACTIVE_PAGE = 'navigation_active_page';

    constructor() {
        this.loadState();
    }

    setFromButtonClick(value: boolean): void {
        this.fromButtonClick = value;
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(value));
    }

    getFromButtonClick(): boolean {
        return this.fromButtonClick;
    }

    clearState(): void {
        this.fromButtonClick = false;
        localStorage.removeItem(this.STORAGE_KEY);
        localStorage.removeItem(this.ACTIVE_PAGE);
    }

    setActivePage(page: 'login' | 'register' | 'recover'): void {
        localStorage.setItem(this.ACTIVE_PAGE, page);
    }

    getActivePage(): string | null {
        return localStorage.getItem(this.ACTIVE_PAGE);
    }

    private loadState(): void {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        this.fromButtonClick = saved ? JSON.parse(saved) : false;
    }
}